import { Injectable } from '@angular/core';

@Injectable()
export class CriteriaValidationService {

  constructor() { }

  public validate(criteria): ValidationResult {
    console.log('validating criteria');

    let validators = this.getValidators(criteria);
    console.log('found ' + validators.length + ' validators');
    let problems = [];

    for(let i = 0; i<validators.length;i++){
      let validator = validators[i];
      let probs = validator(criteria);
      console.log('found ' + probs.length + ' probs');
      problems = problems.concat(probs);
    }

    let result = new ValidationResult();
    result.validationProblems = problems;

    console.log('validation result: ' + JSON.stringify(result));
    return result;
  }

  getValidators(criteria) {
    let validators = [];

    if (criteria.reportConfig.selectedType.id === 5) 
      validators.push(x => this.checkDrugSusceptibilityCrosstabDrugCount(x));
    
    validators.push(x => this.molecularValidator(x));

    return validators;
  }

  checkDrugSusceptibilityCrosstabDrugCount(crit) {
    let drugCount = crit.drugs.selectedItems.length;
    if (drugCount < 2)
      return ["You must select at least two drugs for this report type"];
    if (drugCount > 8)
      return ["You cannot select more than 8 drugs for this report type"];

    return [];
  }

  molecularValidator(crit){
    let problems = [];

    let emptyGroups = false;
    let hasInvalidFilters = false;
    let me = this;
    for(let i = 0; i<crit.MolecularCriteria.Groups.length; i++){
      let group = crit.MolecularCriteria.Groups[i];
      if(group.MolecularCriterias.length < 1)
        emptyGroups = true;
      
      for(let j=0; j<group.MolecularCriterias.length && !hasInvalidFilters; j++){
        let molCrit = group.MolecularCriterias[j];
        if(!me.isMolFilterValid(molCrit))
          hasInvalidFilters = true;
      }
    }

    if(emptyGroups)
      problems.push("Molecular groups cannot be empty");
    
    if(hasInvalidFilters)
      problems.push("One or more of the specified molecular filters is invalid");

    return problems;
  }

  public isMolFilterValid(filter){
    if(filter.IsPositive === undefined)
      return false;

    if(!filter.Test)
      return false;

    if(filter.IsPositive === null && filter.TestResults.length === 0)
      return false;

    return true;
  }
}

export class ValidationResult {
  public get isValid() {
    return this.validationProblems.length === 0;
  }
  public validationProblems: string[];
}
